<template>
  <div>
    <div class="installment" v-if="key1 == '11'">
      <div class="installment_title">
        <img src="@/assets/image/PersonalCenter/MyAccount/contentItemTitle.png" alt="">
        分期购计算器
      </div>
      <div class="installment_inputG">
        <div id="amount">
          金额：
          <el-input v-model="amount" placeholder="请输入" :maxlength="6" @input="amountChange"></el-input>
        </div>
        <div id="downPay">
          首付：
          <el-select v-model="downPay" :popper-append-to-body="false" placeholder="请选择" @change="downPayChange">
            <el-option
              v-for="(item,index) in downPaySelect"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div id="staging">
          期数：
          <el-select v-model="staging" :popper-append-to-body="false" placeholder="请选择" @change="stagingChange">
            <el-option
              v-for="(item,index) in stagingSelect"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="installment_content">
        <div class="installment_content_left contentItem">
          <div>首付款：{{ downPayMoney }}</div>
          <div>总还款：{{ totalMoney }}</div>
        </div>
        <div class="installment_content_right contentItem">
          <div class="monthlyPayment_title">月付款：</div>
          <div class="monthlyPayment">
            <div v-for="(item,index) in monthlyPayment" :key="index">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ql-container ql-snow">
      <p class="aboutContent ql-editor" v-html="pageInfo"></p>
    </div>
    <div class="cooperative_partner" v-if="key1 == '7'">
      <div class="cooperative_partner-title">
        <div></div>
        博淳网络合作伙伴
      </div>
      <div class="cooperative_partner-list">
        <div class="cooperative_partner-list-card" v-for="(item,index) in cooperativePartnerList" :key="index" @click="handleLicense(item.license)">
          <img :src="item.img" alt="">
          <!-- <div class="cooperative_partner-list-card-name">
            {{ item.name }}
          </div> -->
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import {apiPageInfo} from "@/request/API";

export default {
  name: '',
  props: {
    key1: String,
  },
  components: {},
  data() {
    return {
      pageInfo: '',
      // 分期购 金额
      amount: '',
      // 分期购 首付下拉框
      downPaySelect: [
        {value: 3, label: '首付三成'},
        {value: 4, label: '首付四成'},
        {value: 5, label: '首付五成'},
        {value: 6, label: '首付六成'},
      ],
      // 分期购 首付
      downPay: 3,
      // 分期购 期数下拉框
      stagingSelect: [
        {value: 1, label: '一期'},
        {value: 2, label: '二期'},
        {value: 3, label: '三期'},
      ],
      // 分期购 期数
      staging: 1,
      // 分期购 首付款
      downPayMoney: '',
      // 分期购 首付款
      totalMoney: '',
      // 分期购 月付款
      monthlyPayment: [],
      // 分期购 尾款
      finalMoney: 0,
      // 分期购 本息
      principalAndInterest: 0,
      // 合作伙伴
      cooperativePartnerList: [
        {
          img: require('@/assets/image/About/partner/huya.png'),
        },
        {
          img: require('@/assets/image/About/partner/douyu.png'),
        },
        {
          img: require('@/assets/image/About/partner/blbl.png'),
        },
        {
          img: require('@/assets/image/About/partner/txyyb.png'),
        },
        {
          img: require('@/assets/image/About/partner/huawei.png'),
        },
        {
          img: require('@/assets/image/About/partner/vivo.png'),
        },
        {
          img: require('@/assets/image/About/partner/xiaomi.png'),
        },
        {
          img: require('@/assets/image/About/partner/alipay.png'),
        },
        {
          img: require('@/assets/image/About/partner/sougou.png'),
        },
        {
          img: require('@/assets/image/About/partner/aliyun.png'),
        },
        {
          img: require('@/assets/image/About/partner/baidu.png'),
        },
        {
          img: require('@/assets/image/About/partner/360.png'),
        },
      ]
    }
  },
  methods: {
    getPageInfo() {
      apiPageInfo({
        id: this.key1
      }).then(res => {
        this.pageInfo = res.data.content
      })
    },
    amountChange() {
      this.monthlyPaymentCom()
      if (!this.amount) {
        this.downPayMoney = ''
        this.totalMoney = ''
        this.monthlyPayment = []
      }
    },
    downPayChange() {
      this.amountChange()
    },
    stagingChange() {
      this.amountChange()
    },
    monthlyPaymentCom() {
      this.downPayMoney = parseFloat(this.amount * (this.downPay / 10)).toFixed(0)
      this.finalMoney = this.amount - this.downPayMoney
      this.monthlyPayment = []
      this.principalAndInterest = 0
      this.totalMoney = 0
      //每月月供
      let total = 0
      //每月本金
      let money = 0
      //每月利息
      let interest = 0
      //每月本金 = 尾款 / 期数
      money = parseFloat((this.finalMoney) / this.staging).toFixed(0)
      for (let i = 0; i < this.staging; i++) {
        // 利息 = 尾款 * 0.1
        if (this.finalMoney < 10000) {
          interest = parseFloat(this.finalMoney * 0.1).toFixed(0)
        } else {
          interest = parseFloat(this.finalMoney * 0.08).toFixed(0)
        }
        //剩余尾款 = 尾款 - 每月本金
        this.finalMoney = this.finalMoney * 1 - money
        //每月月供 = 本金 + 利息
        total = money * 1 + interest * 1
        this.monthlyPayment.push(i + 1 + '期: ￥' + total + ' （ 本金￥' + money + ' + 折损费￥' + interest + ' ）')
        //本利 = 每月月供总和
        this.principalAndInterest = this.principalAndInterest + total
      }
      //总还款 = 本息 + 首付款
      this.totalMoney = this.principalAndInterest * 1 + this.downPayMoney * 1
    },

    /**
     * 查看合作伙伴营业执照
     * @param url
     */
    handleLicense(url){
      // window.open(url, '_blank')
    }
  },
  mounted() {
    this.getPageInfo()
  },
  watch: {
    key1(val, oldVal) {//普通的watch监听
      this.key1 = val
      this.getPageInfo()
    },
  },
  computed: {}
}
</script>

<style scoped>
.ql-container {
  border: none !important;
  padding: 36px 48px 64px;
  background: var(--bg-card, #FFFFFF);
  box-sizing: border-box;
}

.aboutContent {
  padding: 0;
  /*width: 871px;*/
  overflow: auto;
  margin: 0;
  font-size: 15px;
  line-height: 1.9;
  color: var(--text-secondary, #5A5F6B);
  word-break: break-word;
}

.aboutContent >>> h1,
.aboutContent >>> h2,
.aboutContent >>> h3 {
  position: relative;
  margin: 28px 0 16px;
  padding-bottom: 7px;
  color: var(--text-main, #1A1D24);
  font-weight: 700;
  line-height: 1.45;
}

.aboutContent >>> h1:first-child,
.aboutContent >>> h2:first-child,
.aboutContent >>> h3:first-child {
  margin-top: 0;
}

.aboutContent >>> h2 {
  font-size: 22px;
}

.aboutContent >>> h3 {
  font-size: 18px;
}

.aboutContent >>> h1::after,
.aboutContent >>> h2::after,
.aboutContent >>> h3::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 34px;
  height: 3px;
  background: var(--primary, #FF5A1F);
}

.aboutContent >>> img {
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px;
}

</style>
<style lang="less" scoped>
.installment {
  padding: 50px 40px 0 40px;
  //background: lightpink;
  .installment_title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: var(--text-main, #1A1D24);
    line-height: 28px;
    display: flex;
    align-items: center;
    flex-direction: row;
    position: relative;
    padding-bottom: 7px;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 3px;
      background: var(--primary, #FF5A1F);
    }

    img {
      margin: 0 20px 0 0;
    }
  }

  .installment_inputG {
    margin: 30px 0 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;

    div {
      flex: 1;
      font-size: 18px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: #8F8F8F;
      line-height: 25px;

      /deep/ .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F) !important;
      }

      /deep/ .el-select-dropdown__item.hover {
        background-color: var(--bg-tag, #F0EDE8);
      }

      /deep/ .el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
      }

      /deep/ .el-input.is-focus .el-input__inner {
        border-color: var(--primary, #FF5A1F) !important;
      }
    }

    #amount {
      display: flex;
      flex-direction: row;
      align-items: center;

      /deep/ .el-input__inner {
        width: 193px !important;
        font-size: 14px;
        //color: #C0C4CC;
        line-height: 14px;
      }

    }

    #downPay {
    }

    #staging {
    }
  }

  .installment_content {
    width: 796px;
    height: 72px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    display: flex;
    flex-direction: row;
    padding: 20px 35px;

    .contentItem {
      font-size: 18px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: #8F8F8F;
      line-height: 25px;
    }

    .installment_content_left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 35%;

      div {
        width: 100%;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .installment_content_right {
      width: 65%;
      display: flex;
      flex-direction: row;

      .monthlyPayment_title {
        width: 72px;
      }

      .monthlyPayment {
        width: calc(~"100% -  72px");

        div {
          width: 100%;
          height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

      }
    }
  }
}

.cooperative_partner {
  margin: 71px 0 112px 67px;

  &-title {
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #545454;

    div {
      width: 32px;
      height: 12px;
      background: var(--primary, #FF5A1F);
      margin: 0 0 7px;
    }
  }

  &-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &-card {
      width: 191px;
      height: 118px;
      background: #FFFFFF;
      box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.06);
      border-radius: 4px 4px 4px 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 30px 20px 0 0;
      cursor: pointer;

      img {
        width: 160px;
        height: 80px;
        margin: 0 0 8px;
      }

      &-name {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #A0A0A0;
      }
    }
  }
}
</style>
